import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { 
    BookText, Plus, Save, Trash2, Edit, X, RefreshCw, 
    CheckCircle, AlertCircle, Cpu, AlertTriangle // AlertTriangle eklendi
} from 'lucide-react';

// --- 1. YENİ ONAY MODALI ---
const ConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 transition-all">
      <div className="bg-gray-800 border border-gray-700 rounded-2xl shadow-2xl p-6 max-w-sm w-full transform scale-100 transition-all">
        <div className="flex flex-col items-center text-center">
          <div className="p-3 rounded-full mb-4 bg-orange-900/30 text-orange-400">
            <AlertTriangle size={40} />
          </div>
          <h3 className="text-xl font-bold text-white mb-2">Emin misiniz?</h3>
          <p className="text-gray-400 mb-6 text-sm">
            Bu anlatım tarzını silmek üzeresiniz. Bu işlem geri alınamaz.
          </p>
          <div className="flex gap-3 w-full">
             <button 
                onClick={onClose} 
                className="flex-1 py-2.5 rounded-xl font-semibold text-gray-300 bg-gray-700 hover:bg-gray-600 transition"
            >
                Vazgeç
            </button>
            <button 
                onClick={onConfirm} 
                className="flex-1 py-2.5 rounded-xl font-semibold text-white bg-red-600 hover:bg-red-700 shadow-lg shadow-red-900/20 transition"
            >
                Evet, Sil
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const StatusModal = ({ isOpen, type, message, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="bg-gray-800 border border-gray-700 rounded-2xl shadow-2xl p-6 max-w-sm w-full">
        <div className="flex flex-col items-center text-center">
          <div className={`p-3 rounded-full mb-4 ${type === 'success' ? 'bg-green-900/30 text-green-400' : 'bg-red-900/30 text-red-400'}`}>
            {type === 'success' ? <CheckCircle size={40} /> : <AlertCircle size={40} />}
          </div>
          <h3 className="text-xl font-bold text-white mb-2">{type === 'success' ? 'Başarılı!' : 'Hata!'}</h3>
          <p className="text-gray-400 mb-6">{message}</p>
          <button onClick={onClose} className="w-full py-2.5 rounded-xl font-semibold text-white bg-gray-700 hover:bg-gray-600 transition">Tamam</button>
        </div>
      </div>
    </div>
  );
};

const AdminNarrationsPage = () => {
    const API_URL = process.env.REACT_APP_API_URL;
    
    const [styles, setStyles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingId, setEditingId] = useState(null);
    
    const [formData, setFormData] = useState({ style: '', explanation: '', prompt: '' });
    const [statusModal, setStatusModal] = useState({ open: false, type: 'success', message: '' });

    // --- 2. SİLME MODALI İÇİN STATE ---
    const [deleteModal, setDeleteModal] = useState({ open: false, id: null });

    const fetchStyles = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_URL}/api/admin/styles`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setStyles(res.data);
        } catch (error) {
            console.error("Veri çekme hatası:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStyles();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');

        if (!formData.style || !formData.explanation || !formData.prompt) {
            setStatusModal({ open: true, type: 'error', message: 'Lütfen tüm alanları doldurun.' });
            return;
        }

        try {
            if (editingId) {
                await axios.put(`${API_URL}/api/admin/styles/${editingId}`, formData, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setStatusModal({ open: true, type: 'success', message: 'Anlatım tarzı güncellendi.' });
            } else {
                await axios.post(`${API_URL}/api/admin/styles`, formData, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setStatusModal({ open: true, type: 'success', message: 'Yeni tarz eklendi.' });
            }
            
            setFormData({ style: '', explanation: '', prompt: '' });
            setEditingId(null);
            fetchStyles();

        } catch (error) {
            setStatusModal({ open: true, type: 'error', message: 'İşlem sırasında hata oluştu.' });
        }
    };

    // --- 3. SİLME BUTONUNA BASINCA MODALI AÇ ---
    const confirmDelete = (id) => {
        setDeleteModal({ open: true, id });
    };

    // --- 4. MODALDA "EVET" DENİRSE SİLME İŞLEMİNİ YAP ---
const executeDelete = async () => {
        const id = deleteModal.id;
        if (!id) return;

        const token = localStorage.getItem('token');
        try {
            await axios.delete(`${API_URL}/api/admin/styles/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            // Başarılıysa
            fetchStyles();
            if (editingId === id) {
                setFormData({ style: '', explanation: '', prompt: '' });
                setEditingId(null);
            }
            setStatusModal({ open: true, type: 'success', message: 'Anlatım tarzı başarıyla silindi.' });
            
        } catch (error) {
            // HATA YÖNETİMİ REVİZE EDİLDİ
            console.error(error);
            
            // Backend'den gelen özel mesajı al (Örn: "Bu tarz şu an 5 kullanıcı...")
            const serverMessage = error.response?.data?.detail || 'Silme işlemi sırasında sunucu hatası oluştu.';
            
            setStatusModal({ 
                open: true, 
                type: 'error', 
                message: serverMessage // Backend mesajını göster
            });
            
        } finally {
            // İşlem bitince silme onay modalını her türlü kapat
            setDeleteModal({ open: false, id: null });
        }
    };

    const handleEdit = (item) => {
        setFormData({ 
            style: item.style, 
            explanation: item.explanation,
            prompt: item.prompt || '' // Prompt yoksa boş string
        });
        setEditingId(item.id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="min-h-screen bg-gray-900 text-gray-100 p-6 md:p-12 font-sans">
            {/* Status Modal */}
            <StatusModal 
                isOpen={statusModal.open} 
                type={statusModal.type} 
                message={statusModal.message} 
                onClose={() => setStatusModal({ ...statusModal, open: false })}
            />

            {/* Confirm Delete Modal */}
            <ConfirmModal 
                isOpen={deleteModal.open}
                onClose={() => setDeleteModal({ open: false, id: null })}
                onConfirm={executeDelete}
            />

            <div className="max-w-7xl mx-auto">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500">
                        Anlatım Tarzları Yönetimi
                    </h1>
                    <p className="text-gray-400 mt-1">
                        Kullanıcıya gösterilen metinleri ve Yapay Zeka (Prompt) talimatlarını buradan yönetin.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    
                    {/* SOL KOLON: Form */}
                    <div className="lg:col-span-1">
                        <div className="bg-gray-800 p-6 rounded-2xl border border-gray-700 shadow-xl sticky top-6">
                            <div className="flex items-center gap-3 mb-6 border-b border-gray-700 pb-4">
                                <div className="p-2 bg-indigo-500/20 rounded-lg">
                                    {editingId ? <RefreshCw className="text-orange-400 w-6 h-6"/> : <Plus className="text-indigo-400 w-6 h-6" />}
                                </div>
                                <h2 className="font-bold text-xl text-white">
                                    {editingId ? 'Tarzı Düzenle' : 'Yeni Tarz Ekle'}
                                </h2>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div>
                                    <label className="block text-xs font-medium text-gray-400 mb-1 ml-1">Tarz Adı</label>
                                    <input
                                        type="text"
                                        placeholder="Örn: Edebi Anlatım"
                                        value={formData.style}
                                        onChange={(e) => setFormData({...formData, style: e.target.value})}
                                        className="w-full p-3 bg-gray-900/50 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition"
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-xs font-medium text-blue-400 mb-1 ml-1">Kullanıcı Açıklaması (Görünen)</label>
                                    <textarea
                                        rows="3"
                                        placeholder="Kullanıcı bu tarzı seçerken ne görecek?"
                                        value={formData.explanation}
                                        onChange={(e) => setFormData({...formData, explanation: e.target.value})}
                                        className="w-full p-3 bg-gray-900/50 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition resize-none"
                                    />
                                </div>

                                <div>
                                    <label className="block text-xs font-bold text-purple-400 mb-1 ml-1 flex items-center gap-1">
                                        <Cpu size={12}/> Gemini Prompt (Gizli Talimat)
                                    </label>
                                    <textarea
                                        rows="5"
                                        placeholder="Örn: Sen bir tarih profesörüsün. Mekanı akademik terimlerle, yıl vererek ve mimari detaylara girerek anlat..."
                                        value={formData.prompt}
                                        onChange={(e) => setFormData({...formData, prompt: e.target.value})}
                                        className="w-full p-3 bg-gray-900/50 border border-purple-500/30 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition resize-none"
                                    />
                                    <p className="text-[10px] text-gray-500 mt-1">*Bu kısım kullanıcıya gösterilmez, sadece yapay zekaya gönderilir.</p>
                                </div>

                                <div className="flex gap-3 pt-2">
                                    {editingId && (
                                        <button
                                            type="button"
                                            onClick={() => { setEditingId(null); setFormData({ style: '', explanation: '', prompt: '' }); }}
                                            className="px-4 py-3 bg-gray-700 hover:bg-gray-600 text-gray-300 rounded-xl transition font-medium"
                                        >
                                            <X size={20} />
                                        </button>
                                    )}
                                    <button
                                        type="submit"
                                        className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl font-bold text-white shadow-lg transition transform hover:-translate-y-0.5
                                            ${editingId 
                                                ? 'bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 shadow-orange-900/20' 
                                                : 'bg-gradient-to-r from-indigo-600 to-teal-500 hover:from-indigo-700 hover:to-teal-600 shadow-indigo-900/20'}`}
                                    >
                                        <Save size={18} />
                                        {editingId ? 'Güncelle' : 'Kaydet'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* SAĞ KOLON: Liste */}
                    <div className="lg:col-span-2 space-y-6">
                        {loading ? (
                            <div className="text-center py-12 text-gray-500">Yükleniyor...</div>
                        ) : (
                            <div className="grid gap-4">
                                {styles.map((item) => (
                                    <div 
                                        key={item.id} 
                                        className={`p-5 rounded-2xl border transition group flex flex-col gap-4
                                            ${editingId === item.id 
                                                ? 'bg-indigo-900/20 border-indigo-500 ring-1 ring-indigo-500' 
                                                : 'bg-gray-800 border-gray-700 hover:border-gray-600'}`}
                                    >
                                        <div className="flex items-start justify-between">
                                            <div className="flex gap-3">
                                                <div className="p-3 bg-gray-900 rounded-xl shrink-0 h-fit">
                                                    <BookText className="text-teal-400 w-6 h-6" />
                                                </div>
                                                <div>
                                                    <h3 className="text-lg font-bold text-white mb-1">{item.style}</h3>
                                                    <div className="text-gray-400 text-sm leading-relaxed mb-2">
                                                        <span className="text-xs font-bold text-blue-400 uppercase">Kullanıcı Görüyor:</span> <br/>
                                                        {item.explanation}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex gap-2 shrink-0">
                                                <button 
                                                    onClick={() => handleEdit(item)}
                                                    className="p-2 text-gray-400 hover:text-indigo-400 hover:bg-indigo-500/10 rounded-lg transition"
                                                    title="Düzenle"
                                                >
                                                    <Edit size={18} />
                                                </button>
                                                {/* BURASI GÜNCELLENDİ: confirmDelete çağırılıyor */}
                                                <button 
                                                    onClick={() => confirmDelete(item.id)}
                                                    className="p-2 text-gray-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition"
                                                    title="Sil"
                                                >
                                                    <Trash2 size={18} />
                                                </button>
                                            </div>
                                        </div>

                                        {/* Prompt Gösterimi */}
                                        <div className="bg-gray-900/60 p-3 rounded-lg border border-purple-500/20">
                                            <div className="flex items-center gap-2 mb-1">
                                                <Cpu size={12} className="text-purple-400"/>
                                                <span className="text-[10px] font-bold text-purple-400 uppercase">AI Prompt (Gizli)</span>
                                            </div>
                                            <p className="text-gray-500 text-xs italic font-mono line-clamp-2 hover:line-clamp-none transition-all cursor-default">
                                                "{item.prompt || 'Henüz prompt girilmemiş.'}"
                                            </p>
                                        </div>
                                    </div>
                                ))}

                                {styles.length === 0 && (
                                    <div className="p-8 text-center border border-dashed border-gray-700 rounded-2xl bg-gray-800/50">
                                        <p className="text-gray-500">Henüz eklenmiş bir anlatım tarzı yok.</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AdminNarrationsPage;